<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                this.$l('form_label_search') ||
                  '订单编号/电商平台订单编号/订阅方 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" size="mini" label-width="150px">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="$l('INDEX.Status') || '状态'">
              <el-checkbox-group v-model="form.pushStatusList">
                <el-checkbox label="0">{{
                  $l('choose_notpush') || '未推送'
                }}</el-checkbox>
                <el-checkbox label="1">{{
                  $l('choose_pushsuccess') || '推送成功'
                }}</el-checkbox>
                <el-checkbox label="2">{{
                  $l('choose_pushfail') || '推送失败'
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('table_label_orderNo') || '订单编号'">
              <el-input
                v-model.trim="form.orderNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('table_label_platformOrderNo') || '电商平台订单编号'"
            >
              <el-input
                v-model.trim="form.platformOrderNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('table_label_subscriber') || '订阅方'">
              <el-input
                v-model.trim="form.subscriber"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('table_label_eventName') || '事件名称'">
              <el-input
                v-model.trim="form.eventName"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('table_label_pushResult') || '推送结果'">
              <el-input
                v-model.trim="form.pushResult"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="0">
              <el-form-item :label="$l('INDEX.create_date') || '创建时间'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginCreateTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="beginCreateTimePicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endCreateTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="endCreateTimePicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="0">
              <el-form-item
                :label="$l('table_label_pushpushTime') || '推送时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginPushTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="beginPushTimePicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endPushTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="endPushTimePicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  pushStatusList: ['0', '1', '2'],
}
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },

      //推送日期
      beginPushTimePicker: this.endPushTime(),
      endPushTimePicker: this.beginPushTime(),
      //创建日期限制
      beginCreateTimePicker: this.endCreateTime(),
      endCreateTimePicker: this.beginCreateTime(),
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },

    // 推送日期限制
    endPushTime() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.endPushTime) {
            //如果结束时间不为空，则小于结束时间
            return (
              new Date(self.form.endPushTime).getTime() < time.getTime()
            )
          }
        },
      }
    },
    beginPushTime() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.beginPushTime) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.beginPushTime).getTime() -
                3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    // 创建日期限制
    endCreateTime() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.endCreateTime) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.endCreateTime).getTime() < time.getTime()
          }
        },
      }
    },
    beginCreateTime() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.beginCreateTime) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.beginCreateTime).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
